export default __webpack_public_path__ + "static/media/burglary.2428a042.svg";